import React                       from 'react';
import { Observe }                 from 'rewire-core';
import { WithStyle, withStyles }   from 'rewire-ui';
import { MuiThemeProvider, Theme } from '@material-ui/core/styles';
import { ThemeType }               from '../DataTypes';
import SideTogglePanel, { Anchor } from '../side-navigation/SideTogglePanel';
import getWorkSightInnerTheme      from '../WorkSightInnerTheme';
import MainContent                 from './MainContent';
import mainPageModel               from './MainPageModel';

const styles = (_theme: Theme) => ({
});

type MainPageProps = WithStyle<ReturnType<typeof styles>, {theme: Theme}>;

class MainPage extends React.Component<MainPageProps> {
  theme: Theme;

  constructor(props: MainPageProps) {
    super(props);

    const themeType = 'default' as ThemeType;
    this.theme      = getWorkSightInnerTheme(this.props.theme, themeType);
  }

  render() {
    return (
      <MuiThemeProvider theme={this.theme}>
        <InnerMainPage />
      </MuiThemeProvider>
    );
  }
}

const innerStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    minWidth: '1024px',
    color: theme.palette.neutral.main,
  },
});

type InnerMainPageProps = WithStyle<ReturnType<typeof innerStyles>, any>;

const InnerMainPage = withStyles(innerStyles, class extends React.Component<InnerMainPageProps> {
  constructor(props: InnerMainPageProps) {
    super(props);
    requestAnimationFrame(() => mainPageModel.load());
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    mainPageModel.reset();
  }

  render() {
    const { classes }    = this.props;
    const anchor: Anchor = 'left';

    return <Observe render={() => (
      mainPageModel.isLoaded &&
        <div id='main-page-root' className={classes.root}>
          <SideTogglePanel anchor={anchor} />
          <MainContent />
        </div>
    )} />;
  }
});

export default withStyles(styles, MainPage);
